<h2 mat-dialog-title>Settore</h2>
<div mat-dialog-content class="dialog-center-cont">
  <app-spinner-overlay></app-spinner-overlay>
  <form [formGroup]="formSettori" appFormContainer [larghezza]="3">
    <mat-form-field appFormElement [larghezza]="2" [riempi]="true">
      <mat-label>Settore </mat-label>
      <input matInput placeholder="Settore" formControlName="titolo" />
      <mat-error appFormError></mat-error>
    </mat-form-field>

    <div appFormElement [larghezza]="0" [riempi]="true" style="text-align: center">
      <mat-label>Generico</mat-label>
      <mat-radio-group
        aria-labelledby="Generico"
        formControlName="generico"
        (change)="cambioRadio()"
      >
        <mat-radio-button class="example-radio-button" [value]="true"> Si </mat-radio-button>
        <mat-radio-button class="example-radio-button" [value]="false"> No </mat-radio-button>
      </mat-radio-group>
    </div>

    <mat-form-field appFormElement [larghezza]="3" [riempi]="true">
      <mat-label>Descrizione</mat-label>
      <textarea matInput placeholder="Descrizione" formControlName="descrizione"></textarea>
      <mat-error appFormError></mat-error>
    </mat-form-field>

    <div
      class="separatore"
      appFormElement
      [larghezza]="3"
      *ngIf="this.formSettori.get('generico')?.value === false"
    >
      <app-separatore-label titoloSeparatore="Assegnazioni Codici Ateco"></app-separatore-label>
    </div>

    <!-- ATECO -->
    @if (!formSettori.get('generico')?.value) {
      <app-ateco-selector formControlName="codiciAteco" [required]="isAtecoRequired">
      </app-ateco-selector>
    }
  </form>
</div>
<div mat-dialog-actions class="dialog-footer-cont">
  <div>
    <button mat-dialog-close mat-flat-button color="accent" class="accent-button">Chiudi</button>
  </div>
  <div>
    <button mat-flat-button color="primary" (click)="salva()" class="primary-button">Salva</button>
  </div>
</div>
